<template>
<div>
     <v-list-tile v-if='snapshotevent.path.length > 0'>
                <v-list-tile-content> 
                <v-list-tile-title>{{ snapshotevent.path[snapshotevent.path.length-1] }} : {{snapshotevent.val}}</v-list-tile-title>
                <v-list-tile-sub-title>Action : {{snapshotevent.type}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                  <v-icon v-if='snapshotevent.type==="add"' color='green'>plus</v-icon>
                 <v-icon v-if='snapshotevent.type==="set"' color='blue'>edit</v-icon>
                  <v-icon v-if='snapshotevent.type==="unset"' color='red'>replay</v-icon>
                 <v-icon v-if='snapshotevent.type==="rm"' color='red'>build</v-icon>
              </v-list-tile-action>
               </v-list-tile>

            <v-list-tile v-else >
                <v-list-tile-content> 
                <v-list-tile-title>No Change Made</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                 <v-icon color='green'>check</v-icon>
              </v-list-tile-action>
               </v-list-tile>
</div>
</template>

<script>
export default {
    props : {
        snapshotevent : Object
    },
    methods : {
        formatPath(inputArr){

           var text = inputArr.join();
            text = text.replace(/,/g, '/');
            return text
        }   
    }
}
</script>
